import FormInputText from "@repo/components/src/forms/text";
import { TaxProfileFieldKindEnum } from "@repo/graphql/gql/graphql";
import { ComponentProps } from "react";

import type { TaxProfileFormState } from "./useTaxProfileForm";
import type { TaxProfileFieldData, TextFormName } from "./types";

type InputProps = Pick<
  ComponentProps<typeof FormInputText>,
  "keyboardType" | "textContentType" | "autoCapitalize"
>;

const EMAIL_INPUT: InputProps = {
  keyboardType: "email-address",
  textContentType: "emailAddress",
  autoCapitalize: "none",
};

const TEXT_INPUTS: Record<TextFormName, InputProps> = {
  legalName: {
    keyboardType: "default",
    textContentType: "name",
    autoCapitalize: "words",
  },
  businessActivity: {
    keyboardType: "default",
    textContentType: "none",
    autoCapitalize: "sentences",
  },
  email: EMAIL_INPUT,
  addressLine: {
    keyboardType: "default",
    textContentType: "fullStreetAddress",
    autoCapitalize: "sentences",
  },
};

type Props = {
  field: TaxProfileFieldData;
  name: TextFormName;
  form: TaxProfileFormState;
  size: ComponentProps<typeof FormInputText>["size"];
};

/** A text input; the field's kind decides whether it is an email. */
export default function TextField({ field, name, form, size }: Props) {
  const inputProps =
    field.kind === TaxProfileFieldKindEnum.Email
      ? EMAIL_INPUT
      : TEXT_INPUTS[name];
  return (
    <FormInputText
      control={form.formProps.control}
      name={name}
      label={field.label}
      placeholder={field.placeholder || field.label}
      required={field.required}
      disabled={false}
      className=""
      size={size}
      labelSize={size}
      {...inputProps}
    />
  );
}
